import { FormFieldConfig } from "Components/Common/CommonForm";
import { validations } from "validations/FormValidations";

export const periodColumn = [
  {
    key: "period_sort",
    label: "Period No",
    width: "50%",
  },
  { key: "period_number", label: "Display Period", width: "50%" },
];

export const periodfields: FormFieldConfig[] = [
  {
    name: "period_sort",
    label: "Period No",
    placeholder: "Enter Period No",
    required: true,
    type: "number",
    rules: validations.period.period_sort,
  },
  {
    name: "period_number",
    label: "Display Period",
    type: "number",
    placeholder: "Enter Display Period",
    required: true,
    rules: validations.period.period_number,
  },
];